// Add your custom JS here

// ============================================================
// NEW HORIZON — SCROLL REVEAL
// Watches sections and product cards entering the viewport
// and adds .nh-visible to trigger the CSS fade-up animation.
// ============================================================

(function () {
  // Selectors to animate on scroll
  var targets = [
    '.shopify-section',
    '.product-card',
    '.footer-column',
    '.section-columns .column',
    '.image-text--wrapper',
    '.accordion-item',
    '.blog-card',
  ].join(', ');

  function initReveal() {
    var elements = document.querySelectorAll(targets);

    if (!elements.length) return;

    // Skip the very first section — it uses the CSS page-load animation instead
    var skip = document.querySelector('.shopify-section:first-of-type');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nh-visible');
            observer.unobserve(entry.target); // fire once only
          }
        });
      },
      { threshold: 0.12 }
    );

    elements.forEach(function (el) {
      if (el === skip) return; // first hero already animated by CSS
      el.classList.add('nh-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
